// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__2ZMeK","Label":"Input_Label__2XMBp","InputElement":"Input_InputElement__k202p","Invalid":"Input_Invalid__1NrbT"};